import ZFocusTrap from './src/focus-trap.vue'

export { ZFocusTrap }

export default ZFocusTrap
export * from './src/tokens'
export * from './src/utils'
